import { useState } from 'react';
import { Container, Row, Col, Form, Button, Alert } from 'react-bootstrap';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl';
import { FaEnvelope, FaLock } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import './Login.css';

import tutorImg from '../shared/image/Dial_Tutor.png';

export default function AdminLogin() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr('');
    setBusy(true);
    try {
      await login(email, password, 'admin');
      navigate('/admin/dashboard');
    } catch (e2) {
      setErr(e2.message || 'Login failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <Container fluid className="main-container">
      <Row className="login-card">
        <Col md={6} className="image-section">
          <img src={tutorImg} alt="Dialtutor" />
        </Col>
        <Col md={6} className="form-section">
          <h4 className="mb-4">Admin Log Into Your Account</h4>
          <Form onSubmit={onSubmit}>
            {err && <Alert variant="danger" className="py-2">{err}</Alert>}
            <InputGroup className="mb-3 ingrp">
              <InputGroup.Text><FaEnvelope /></InputGroup.Text>
              <FormControl
                placeholder="Enter your email"
                type="email"
                className="bgin"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </InputGroup>
            <InputGroup className="mb-3 ingrp">
              <InputGroup.Text><FaLock /></InputGroup.Text>
              <FormControl
                type="password"
                placeholder="Password"
                className="bgin"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </InputGroup>
            <Button className="mb-3 subt" type="submit" disabled={busy}>
              {busy ? '...' : 'Login'}
            </Button>
          </Form>
          <h6>
            Forgot password?{' '}
            <Link to="/admin/forgot-password" className="custom-text">
              <strong>Reset</strong>
            </Link>
          </h6>
        </Col>
      </Row>
    </Container>
  );
}
